import { SITESPECT_EXPERIMENT_NAMES } from '../constants/Sitespect';

export function getExperiment(experiment) {
	if (typeof window === 'undefined') return undefined;

	const localStorageValue = window.localStorage.getItem(experiment);
	return localStorageValue || window[experiment];
}

export function getTrialPeriodText(textToReplace) {
	const { TRIAL_PERIOD_EXPERIMENT } = SITESPECT_EXPERIMENT_NAMES;
	const experimentValue = getExperiment(TRIAL_PERIOD_EXPERIMENT);

	if (experimentValue === 'variant') {
		return textToReplace.replace(/14 dagen/g, '7 dagen');
	}
	return textToReplace;
}
